import * as THREE from 'three';
import { Simulation } from './Simulation';
import { CommonClass } from './CommonClass';
import { MouseClass } from './MouseInteraction';
import { makePaletteTexture } from './TextureUtils';
import { face_vert, color_frag } from './Shaders';

export class Output {
  simulation: Simulation;
  scene: THREE.Scene;
  camera: THREE.Camera;
  output: THREE.Mesh;
  Common: CommonClass;
  Mouse: MouseClass;

  constructor(Common: CommonClass, Mouse: MouseClass, colors: string[]) {
    this.Common = Common;
    this.Mouse = Mouse;
    const paletteTex = makePaletteTexture(colors);
    // Hard-code transparent background vector (alpha 0)
    const bgVec4 = new THREE.Vector4(0, 0, 0, 0);
    
    this.simulation = new Simulation(Common, Mouse);
    this.scene = new THREE.Scene();
    this.camera = new THREE.Camera();
    this.output = new THREE.Mesh(
      new THREE.PlaneGeometry(2, 2),
      new THREE.RawShaderMaterial({
        vertexShader: face_vert,
        fragmentShader: color_frag,
        transparent: true,
        depthWrite: false,
        uniforms: {
          velocity: { value: this.simulation.fbos.vel_0!.texture },
          boundarySpace: { value: new THREE.Vector2() },
          palette: { value: paletteTex },
          bgColor: { value: bgVec4 }
        }
      })
    );
    this.scene.add(this.output);
  }

  resize() {
    this.simulation.resize();
  }

  render() {
    if (!this.Common.renderer) return;
    this.Common.renderer.setRenderTarget(null);
    this.Common.renderer.render(this.scene, this.camera);
  }

  update() {
    this.simulation.update();
    this.render();
  }
}
